<template>
  <div class="loader-container">
    <Loader2 class="loader-icon" :size="48" />
    <p class="loader-text">{{ getTranslations('expression_1495') }}</p>
  </div>
</template>

<script>
import { Loader2 } from 'lucide-vue';

export default {
  name: 'LoaderMessages',
  components: {
    Loader2
  }
}
</script>

<style scoped>
.loader-container {
  position: fixed; 
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999; 
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loader-icon {
  animation: spin 1.5s linear infinite;
  color: #60a5fa;
}

.loader-text {
  margin-top: 1rem;
  font-weight: 500;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>